import { APICore } from './apiCore';

const api = new APICore();

export const kpis = (params: any) => {
    return api.get('/dashboard/kpis', { params });
};
export const broadcast_performance = (params: any) => {
    return api.get('/dashboard/subscriber_chat', { params });
};
export const conversation_distribution = (params: any) => {
    return api.get('/dashboard/conversation_distribution', { params });
};
export const template_counts = (params: any) => {
    return api.get('/dashboard/template_counts', { params });
};
export const automation_source = (params: any) => {
    return api.get('/dashboard/automation_source', { params });
};
export const report_counts = (params: any) => {
    return api.get('/dashboard/report_counts', { params });
};
export const ai_automation_count = (params: any) => {
    return api.get('/dashboard/ai_automation_count', { params });
};
export const conversation_growth = (params: any) => {
    return api.get('/dashboard/conversation_growth', { params });
};

export const broadcast_chart = (params: any) => {
    return api.get('/dashboard/broadcast_chart', { params });
};

export const conversation_handling = (params: any) => {
    return api.get('/dashboard/conversation_handling', { params });
};